import { FormControl, FormField } from '@/components/ui/Form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/Select';
import { FormItem, FormLabel } from '@/components/wm';
import React, { useState } from 'react';

// Expects `site` and `indicatorId` fields in the step's form. Only the sites with
// an indicator that passes `filter` are offered, so picking a site never leads to
// an empty indicator list; `emptyLabel` says so when no site has one.
export function SiteIndicatorFields({ data, emptyLabel, filter, form, onChangeField, onIndicatorChange }) {
    const [site, setSite] = useState(form.getValues('site'));

    const
        suitableIndicators = WiseMetering.indicators.filter(filter),
        suitableSiteIds = new Set(suitableIndicators.map(model => model.get('site_id'))),
        sitesOptions = WiseMetering.zones.activeSites()
            .filter(model => suitableSiteIds.has(model.id))
            .map(model => ({ id: model.id, name: model.get('name') })),
        indicatorOptions = suitableIndicators
            .filter(model => model.get('site_id') === site)
            .map(model => ({ id: model.id, model, name: model.get('name') }));

    return (
        <>
            <FormField
                control={form.control}
                name="site"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>{i18next.t('glossary.site').capitalize()}</FormLabel>
                        <FormControl>
                            <Select
                                disabled={sitesOptions.length === 0}
                                onValueChange={val => {
                                    field.onChange(val);
                                    setSite(val);

                                    const selected = sitesOptions.find(i => i.id === val);

                                    onChangeField('subtitle')(selected?.name || '');

                                    form.setValue('indicatorId', '', { shouldValidate: true });
                                    onChangeField('data')({ ...data.data, indicatorId: '' });
                                }}
                                value={field.value}
                            >
                                <SelectTrigger className="tw-ml-0">
                                    <SelectValue placeholder={sitesOptions.length === 0 ? emptyLabel : i18next.t('sites.select_site')}/>
                                </SelectTrigger>
                                <SelectContent>
                                    {sitesOptions.map(option => (
                                        <SelectItem key={option.id} value={option.id}>
                                            {option.name}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </FormControl>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="indicatorId"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>{i18next.t('glossary.indicator').capitalize()}</FormLabel>
                        <FormControl>
                            <Select
                                disabled={!site || indicatorOptions.length === 0}
                                onValueChange={val => {
                                    field.onChange(val);

                                    const selected = indicatorOptions.find(i => i.id === val);

                                    onChangeField('title')(selected?.name || '');
                                    onIndicatorChange(selected?.model, val);

                                    form.trigger('indicatorId');
                                }}
                                value={field.value}
                            >
                                <SelectTrigger className="tw-ml-0">
                                    <SelectValue placeholder={i18next.t('indicators.select_indicator').capitalize()}/>
                                </SelectTrigger>
                                <SelectContent>
                                    {indicatorOptions.map(option => (
                                        <SelectItem key={option.id} value={option.id}>
                                            {option.name}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </FormControl>
                    </FormItem>
                )}
            />
        </>
    );
}

export const savedIndicatorSite = indicatorId => WiseMetering.indicators.get(indicatorId)?.get('site_id') || '';
